import React from "react";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Container,
} from "@mui/material";

import Header from "../components/header";
import Footer from "../components/footer";

const TermsOfService = () => {
  const sections = [
    {
      title: "1. Acceptance of Terms",
      text: "By accessing or using Autoshops.com, you accept and agree to be bound by these Terms. If you do not agree, do not use the Service.",
    },
    {
      title: "2. Services Provided",
      text: "Autoshops.com connects car owners with auto repair shops. Users can submit vehicle diagnostic data, search for shops, leave reviews, and schedule services.",
    },
    {
      title: "3. Account Responsibilities",
      text: "You must provide accurate and complete information when creating an account. You are responsible for all activities under your account.",
    },
    {
      title: "4. User Content",
      text: "You may submit content, including reviews and diagnostic information. You grant Autoshops.com a non-exclusive, royalty-free license to use, display, and distribute your content for platform functionality.",
    },
    {
      title: "5. Use Restrictions",
      text: (
        <ul>
          <li>Misuse the platform for unauthorized purposes.</li>
          <li>Post false, misleading, or defamatory content.</li>
          <li>Reverse engineer or exploit our code or systems.</li>
        </ul>
      ),
    },
    {
      title: "6. Mechanic and Shop Listings",
      text: "Mechanics and shops listed on the platform may be user-submitted. Autoshops.com does not guarantee the accuracy or performance of any third-party service provider.",
    },
    {
      title: "7. Payment and Billing",
      text: "Some features may require payment. Pricing and payment terms will be clearly disclosed prior to use.",
    },
    {
      title: "8. Disclaimers",
      text: "We do not guarantee that the platform will be error-free or uninterrupted. Use of the platform is at your own risk.",
    },
    {
      title: "9. Limitation of Liability",
      text: "Autoshops.com is not liable for damages resulting from use of our service, including but not limited to loss of data, financial loss, or service dissatisfaction.",
    },
    {
      title: "10. Termination",
      text: "We may suspend or terminate your access for violating these terms or for any reason at our sole discretion.",
    },
    {
      title: "11. Governing Law",
      text: "These terms are governed by the laws of the State of Florida.",
    },
    {
      title: "12. Changes",
      text: "We may modify these Terms at any time. We will notify users of material changes via email or platform alerts.",
    },
  ];

  return (
    <>
      {/* Header */}
      <Header />

      {/* Main Content */}
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper
          sx={{
            p: 5,
            borderRadius: 3,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Terms and Conditions
          </Typography>
          <Typography variant="subtitle1" gutterBottom color="text.secondary">
            Effective Date: 8-1-25
          </Typography>

          <Typography paragraph>
            Welcome to Autoshops.com! By accessing or using our website,
            platform, or services (the “Service”), you agree to comply with and
            be bound by these Terms and Conditions. Please read them carefully.
          </Typography>

          <Divider sx={{ my: 3 }} />

          {sections.map((section, idx) => (
            <Box key={idx} sx={{ mb: 3 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: 600, color: "primary.main" }}
              >
                {section.title}
              </Typography>
              <Typography variant="body1" color="text.primary">
                {section.text}
              </Typography>
            </Box>
          ))}
        </Paper>
      </Container>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default TermsOfService;
